import React from 'react';
import { Upload } from 'antd';

import styled from 'styled-components';
import Button from '@joinforma/ui/components/Button';
import Body2 from '@joinforma/ui/components/Body2';
import { ReactComponent as UploadSvg } from '@joinforma/ui/assets/icons/legacy/upload.svg';
import { SCREEN_WIDTHS } from '@joinforma/ui/constants/breakpoints';

import { getAvatarURL } from 'utils/cloudinary';
import {
  BUTTON_VARIANTS,
  BUTTON_SIZES,
} from '@joinforma/ui/constants/properties';

const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 48px;
  @media (min-width: ${SCREEN_WIDTHS.MOBILE_LANDSCAPE}) {
    flex-direction: row;
  }
`;
const ProfileBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  @media (min-width: ${SCREEN_WIDTHS.MOBILE_LANDSCAPE}) {
    margin-bottom: 0;
  }
`;

const UploadContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding-bottom: 20px;
`;

const UploadText = styled(Body2)`
  display: block;
  color: ${({
    theme: {
      colors: {
        text: { secondary },
      },
    },
  }) => secondary};

  margin-bottom: 16px;
`;
const ImageContainer = styled.div``;

const StyledButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.SECONDARY,
  start_icon: UploadSvg,
  size: BUTTON_SIZES.SMALL,
})``;

interface File extends Blob {
  readonly lastModified: number;
  readonly name: string;
}

const Avatar = ({
  avatar_url,
  disabled,
  uploading,
  onAvatarUpload,
}: {
  avatar_url: string;
  disabled?: boolean;
  uploading?: boolean;
  onAvatarUpload: (file: File) => boolean | Promise<true | undefined>;
}) => {
  const renderImage = (avatar_url: string) => {
    const DEFAULT_IMAGE_URL =
      'https://s3-us-west-1.amazonaws.com/twic.ai/avatar/default_avatar.png';
    const img = avatar_url ? avatar_url : DEFAULT_IMAGE_URL;

    return (
      <ImageContainer>
        <img
          src={
            img.startsWith('https')
              ? getAvatarURL(img, {
                  width: 80,
                  height: 80,
                  radius: 'max',
                })
              : img
          }
          alt="avatar"
          style={{ width: '80px', height: '80px' }}
        />
      </ImageContainer>
    );
  };

  const handleUpload = (file: File) => {
    onAvatarUpload(file);
    return false;
  };

  return (
    <AvatarContainer>
      <ProfileBlock>
        <UploadText>Upload profile picture.</UploadText>
        {renderImage(avatar_url)}
      </ProfileBlock>
      {!disabled && (
        <UploadContainer>
          <Upload
            accept=".png,.jpg,.jpeg"
            showUploadList={false}
            multiple={false}
            beforeUpload={handleUpload}
          >
            <StyledButton loading={uploading}>Replace image</StyledButton>
          </Upload>
        </UploadContainer>
      )}
    </AvatarContainer>
  );
};

export default Avatar;
